<template>


      <VueCodeHighlight>
        <pre class="language-javascript">
<code>

  // Install with NPM
npm i -S scatterjs-core
npm i -S scatterjs-plugin-eosjs2    // eosjs@beta

// or ..

// For use in HTML files
src="https://cdn.scattercdn.com/file/scatter-cdn/js/latest/scatterjs-plugin-eosjs2.min.js"
src="https://cdn.scattercdn.com/file/scatter-cdn/js/latest/scatterjs-core.min.js"
 
EXAMPLE

import ScatterJS from 'scatterjs-core';
import ScatterEOS from 'scatterjs-plugin-eosjs';
import Eos from 'eosjs';

// Don't forget to tell ScatterJS which plugins you are using.
ScatterJS.plugins( new ScatterEOS() );

// Networks are used to reference certain blockchains.
// They let you get accounts and help you build signature providers.
const network = {
    blockchain:'eos',
    protocol:'https',
    host:'api-testnet.telosmadrid.io',
    port:443,
    chainId:'e17615decaecd202a365f4c029f206eee98511979de8a5756317e2469f2289e3'
}

// First we need to connect to the user's Scatter.
ScatterJS.scatter.connect('*MY APP NAME*').then(connected => { // Add your app name here

    // If the user does not have Scatter or it is Locked or Closed this will return false;
    if(!connected) return false;

    const scatter = ScatterJS.scatter;

    // Now we need to get an identity from the user.
    // We're also going to require an account that is connected to the network we're using.
    const requiredFields = { accounts:[network] };
    scatter.getIdentity(requiredFields).then(() => {

        // Always use the accounts you got back from Scatter. Never hardcode them even if you are prompting
        // the user for their account name beforehand. They could still give you a different account.
        const account = scatter.identity.accounts.find(x => x.blockchain === 'eos');

        // You can pass in any additional options you want into the eosjs reference.
        const eosOptions = { expireInSeconds:60 };

        // Get a proxy reference to eosjs which you can use to sign transactions with a user's Scatter.
        const eos = scatter.eos(network, Eos, eosOptions);

        // ----------------------------
        // Now that we have an identity,
        // an EOSIO account, and a reference
        // to an eosjs object we can send a transaction.
        // ----------------------------

        // Never assume the account's permission/authority. Always take it from the returned account.
        const transactionOptions = { authorization:[`${account.name}@${account.authority}`] };

        eos.contract('{{account}}').then(contract => {    
          contract.transfer(account.name, 'helloworld', '1.0000 EOS', 'memo', transactionOptions).then(trx => {
            // That's it!
            console.log(`Transaction ID: ${trx.transaction_id}`);
          }).catch(error => {
            console.error(error);
          });
        })

    }).catch(error => {
        // The user rejected this request, or doesn't have the appropriate requirements.
        console.error(error);
    });
});

</code>
<code>
 




</code>
<code>
  CREATE ASSET // This is the first action you will perform

  eos.contract('{{account}}').then(contract => {    
    contract.create({{account}}, symbol, transactionOptions).then(trx => { // symbol ex ('SYM', 'EOS', 'ASDF')
      console.log(`Transaction ID: ${trx.transaction_id}`);
    }).catch(error => {
      console.error(error);
    });
  })














</code>
<code>




  BURN ASSET // Distroy a created asset

  eos.contract('{{account}}').then(contract => {    
    contract.burn({{account}}, token_id, transactionOptions).then(trx => { // burn
      console.log(`Transaction ID: ${trx.transaction_id}`);
    }).catch(error => {
      console.error(error);
    });
  })



  















</code>
<code>
  ISSUE ASSET TO ACCOUNT

  eos.contract('{{account}}').then(contract => {    
    contract.issue(to, quantity, uris, name, memo, transactionOptions).then(trx => {
    console.log(`Transaction ID: ${trx.transaction_id}`);
  }).catch(error => {
    console.error(error);
  });

</code>
<code>
 

















</code>
<code>
  ASSET TRANSFER

  eos.contract('{{account}}').then(contract => {    
    contract.transfer(from, to, quantity, memo, transactionOptions).then(trx => { quantity ie (1.0000 SYMBOL)
      // That's it!
      console.log(`Transaction ID: ${trx.transaction_id}`);
    }).catch(error => {
      console.error(error);
    });
  })














</code>
<code>







  TRANSFER ID

  eos.contract('{{account}}').then(contract => {    
    contract.issue(from, to, id, memo, transactionOptions).then(trx => {
      // That's it!
      console.log(`Transaction ID: ${trx.transaction_id}`);
    }).catch(error => {
      console.error(error);
    });
  })










</code>
          </pre>
        </VueCodeHighlight>


      <!--                           END TOKEN NODE JS                       -->


  
</template>

<script>
  import store from "@/store"

  import { component as VueCodeHighlight } from 'vue-code-highlight';

  export default {
    data () {
      return {
 
        abc: '123',
        items: [
          { x: 100, text: 'Getting started' },
          { x: 2000, text: 'Create' },
          { x: 3050, text: 'Issue' },
          { x: 4050, text: 'Transfer' },
          { divider: true },
        ]
      }
    },
    components: {
      VueCodeHighlight
    },
    props: {
      keys: String,
      account: String
    },
    watch:  {
 
    
    },
    methods: {
      goto(x) {
        this.$vuetify.goTo(x)
      }
    },
    destroyed: function () {
    }
  }
</script>

<style>
  .test {
    color:red;
  }
</style>
